import { ol_Feature, ol_geom } from "@omnia/exports/openlayers"
import { avg, Datalayer, DatalayersMap, DatalayerZone, map } from "../../../../omnia"
import { IDatalayersService } from "../../../../types"

interface ZoneState {
    zone: DatalayerZone,
    initNumber: number
}

export class NumberOperation {

    public nextNumber: number
    public enableManualMode: boolean

    private watcher: Function

    private initState: ZoneState[]
    private edits: ZoneState[]

    constructor(private svc: IDatalayersService, private map: DatalayersMap, private layer: Datalayer, private outerGeometry: () => ol_geom.Geometry, private apply: () => void) {
    }

    start() {

        this.stop()

        this.nextNumber = 1
        this.enableManualMode = false
        this.initState = this.layer.zones.map(zone => ({ zone, initNumber: zone.zoneNumber }))
        this.watcher = this.map.watchSelection(f => this.allocateNextNumber(f))

    }

    stop() {

        this.cancel()

        this.edits = []

        if (this.watcher) {
            this.watcher()
            this.watcher = undefined
        }

    }

    private cancel() {

        if (this.edits) {

            this.edits.forEach(e => {
                e.zone.zoneNumber = e.initNumber
            })

            this.layer.refresh()

        }

    }

    canCommit() {
        return this.edits && (this.edits.length > 0)
    }

    commit() {
        this.edits = undefined
        return true
    }

    restart() {
        this.nextNumber = 1
        this.map.clearSelection()
    }

    private allocateNextNumber(features: ol_Feature[]) {

        if (!this.enableManualMode) return

        if (features && (features.length == 1)) {

            const zone = features[0].get("data") as DatalayerZone

            if (zone instanceof DatalayerZone) {

                const edit = this.edits.find(e => e.zone == zone)

                if (!edit) {
                    this.edits.push({
                        zone,
                        initNumber: zone.zoneNumber
                    })
                }

                zone.zoneNumber = this.nextNumber++
                zone.refresh()

                this.apply && this.apply()

            }


        }

    }

    renumberAuto() {

        this.edits = this.initState.slice()

        renumber(this.outerGeometry(), this.layer)

        this.map.clearSelection()
        this.layer.refresh()

    }

}


function renumber(outerGeometry: ol_geom.Geometry, layer: Datalayer) {

    type Cell = map.grid.GridCell

    const extent = map.grid.createGridFromExtent(outerGeometry.getExtent(), 50)

    const zones = layer.zones.map((zone, index) => ({
        zone,
        key: String(index),
        geometry: zone.feature.getGeometry()
    }))

    const grid = map.grid.createGrid(extent, { zones })

    const { rows, cols } = grid.grid

    const getRank = (c: Cell) => ((rows - c.row) * cols) + c.col

    const temp1 = zones.map(z => {

        const cells = (grid.getCells(z.key) ?? [])
            .map(getRank)
            .sort((a, b) => a - b)

        return ({
            zone: z.zone,
            cells,
            avg: avg(cells.slice(0, 10), c => c)
        })

    })

    const temp2 = temp1.sort((a, b) => a.avg - b.avg)

    let number = 0
    for (const t of temp2) {
        t.zone.zoneNumber = ++number
    }

}
